// TODO: add proper CRM Search filters types

export const isCRMSearchFilters = thing => {
  if (typeof thing === 'object' && thing !== null && typeof thing.objectTypeId === 'string' && Array.isArray(thing.filterGroups)) {
    return true;
  }
  return false;
};